"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  blue: {
    lighten1: '#424b5f',
    lighten2: '#3f4f6c',
    lighten3: '#3d4a69',
    lighten4: '#6988CD',
    darken4: '#2940a2',
    accent4: '#2f4ff1'
  },
  lighBlue: {
    lighten1: '#489ce9',
    darken1: '#79a3ff',
    darken2: '#5B8CF7',
    darken3: '#387ef8',
    accent3: '#51AFEC',
    accent3Transparent: 'rgba(81, 175, 236, 0.2)',
    accent4: '#4184f9'
  },
  blueGray: {
    lighten1: '#8190a9',
    lighten2: '#a7b6d6',
    lighten4: '#dfe5ea',
    darken4: '#32415e',
    darken1: '#2f3b52',
    darken5: '#2A364E',
    darken2: '#212a3c'
  },
  indigo: {
    accent1: '#8a97cc',
    accent2: '#355681',
    accent3: '#455e88',
    accent4: '#4f5d77',
    darken1: '#3C648A',
    darken1Transparent: 'rgba(60, 100, 138, 0.2)'
  },
  white: {
    primary: '#FFF',
    transparent: 'rgba(255, 255, 255, 0.9)'
  },
  orange: '#FF9145',
  red: '#F12A1C',
  green: {
    accent3: '#08C281',
    transparent: 'rgba(8, 236, 186, 0.28)'
  },
  gray: {
    darken1: '#778197',
    darken2: '#606B82',
    lighten1: '#a4acb8'
  }
};
exports["default"] = _default;